import React, { useState } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { gallery } from "../data/mock";

export default function Gallery() {
  const [active, setActive] = useState(null);

  const close = () => setActive(null);
  const next = (e) => {
    e?.stopPropagation();
    setActive((a) => (a + 1) % gallery.length);
  };
  const prev = (e) => {
    e?.stopPropagation();
    setActive((a) => (a - 1 + gallery.length) % gallery.length);
  };

  return (
    <section className="relative py-24 lg:py-32 bg-[#08080a]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-12 reveal">
          <div>
            <div className="text-[11px] uppercase tracking-[0.3em] text-amber-accent mb-4">Gallery</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05] max-w-2xl">
              From the <span className="text-amber-accent">field.</span>
            </h2>
          </div>
          <p className="max-w-md text-white/65">A glimpse into the daily craft, steelwork, concrete, formwork and the people who deliver it.</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 lg:gap-4">
          {gallery.map((src, i) => (
            <button
              key={i}
              onClick={() => setActive(i)}
              className={`relative overflow-hidden rounded-lg group reveal ${
                i % 5 === 0 ? "col-span-2 row-span-2 aspect-square" : "aspect-[4/3]"
              }`}
              style={{ transitionDelay: `${i * 50}ms` }}
            >
              <img src={src} alt="" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors" />
              <div className="absolute bottom-3 left-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity">
                <div className="text-xs text-white font-medium tracking-wider uppercase">View</div>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {active !== null && (
        <div
          className="fixed inset-0 z-[100] bg-black/95 backdrop-blur-md flex items-center justify-center p-4 lg:p-10"
          onClick={close}
        >
          <button
            onClick={close}
            className="absolute top-5 right-5 w-11 h-11 rounded-full bg-white/10 hover:bg-white/20 border border-white/15 flex items-center justify-center text-white"
            aria-label="Close"
          >
            <X className="w-5 h-5" />
          </button>
          <button
            onClick={prev}
            className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white/10 hover:bg-[#F5D000] hover:text-black border border-white/15 flex items-center justify-center text-white"
            aria-label="Previous"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          <button
            onClick={next}
            className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white/10 hover:bg-[#F5D000] hover:text-black border border-white/15 flex items-center justify-center text-white"
            aria-label="Next"
          >
            <ChevronRight className="w-5 h-5" />
          </button>
          <img
            src={gallery[active]}
            alt=""
            onClick={(e) => e.stopPropagation()}
            className="max-h-[88vh] max-w-[92vw] object-contain rounded-lg shadow-2xl"
          />
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-xs tracking-[0.25em] uppercase text-white/70">
            {String(active + 1).padStart(2, "0")} / {String(gallery.length).padStart(2, "0")}
          </div>
        </div>
      )}
    </section>
  );
}
